// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"743":"bab01fca","2301":"a289fe69"}[chunkId] + ".chunk.css";
};